import { mapGetters } from 'vuex';
import templateBuilder from '@/helpers/templateBuilder';
import ProductList from '@/components/ProductList/index.vue';
import TabLoader from '@/components/TabLoader/index.vue';

export default {
  name: 'CompatibleDevices',
  components: {
    ProductList,
    TabLoader,
  },
  computed: {
    ...mapGetters({
      devicesData: 'getActiveCompatibleDevices',
      productUrlTemplate: 'getProductUrl',
      devicesLoading: 'getDevicesLoading',
    }),
    devices() {
      return this.devicesData.map((device) => ({
        ...device,
        link: templateBuilder(this.productUrlTemplate, { productId: device.productId }),
      }));
    },
  },
};
